import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import { initSentry } from './sentry'
import { AlertCircle, RefreshCw } from 'lucide-react'

// Initialize Sentry before rendering the app
initSentry()

const SentryFallback = ({ error, resetError }: { error: unknown; resetError: () => void }) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
        <div className="flex justify-center mb-4">
          <AlertCircle className="w-16 h-16 text-red-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          אופס, משהו השתבש
        </h1>
        <p className="text-gray-600 mb-6">
          מצטערים, אירעה שגיאה בלתי צפויה. אנחנו כבר עובדים על תיקון הבעיה.
        </p>
        {errorMessage && (
          <div className="mb-4 p-3 bg-gray-100 rounded text-left">
            <p className="text-xs font-mono text-gray-700 break-all">
              {errorMessage}
            </p>
          </div>
        )}
      <div className="flex gap-3 justify-center">
        <button
          onClick={resetError}
          className="inline-flex items-center gap-2 px-6 py-3 bg-gray-200 text-gray-800 rounded-lg font-medium hover:bg-gray-300 transition-colors min-h-[44px]"
        >
          נסה שוב
        </button>
        <button
          onClick={() => window.location.reload()}
          className="inline-flex items-center gap-2 px-6 py-3 bg-black text-white rounded-lg font-medium hover:bg-gray-800 transition-colors min-h-[44px]"
        >
          <RefreshCw className="w-5 h-5" />
          <span>רענן דף</span>
        </button>
      </div>
    </div>
  </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary 
      fallback={SentryFallback}
      showDialog={false}
    >
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
